import { render, staticRenderFns } from "./CleansingIndex.vue?vue&type=template&id=5547ff48&"
import script from "./CleansingIndex.vue?vue&type=script&lang=js&"
export * from "./CleansingIndex.vue?vue&type=script&lang=js&"
import style0 from "./CleansingIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports